module.exports = __webpack_public_path__ + "img/p29266.502c4022.jpg";